// extracted by mini-css-extract-plugin
export default {"grid":"style_grid__GMTcB","active":"style_active__REkQf","selected":"style_selected__K+P4p","dot-container":"style_dot-container__wgyah"};